/* eslint-disable import/prefer-default-export */ import window from "../shared/window";
var previousFrame = null;
export function downloadFile(uri) {
    var iframe = window.document.createElement("iframe");
    iframe.src = uri;
    iframe.setAttribute("style", "display: none");
    if (previousFrame) {
        window.document.body.removeChild(previousFrame);
    }
    previousFrame = iframe;
    window.document.body.append(iframe);
}

//# sourceMappingURL=downloadFile.js.map